/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finishCreditMultiStepLoad} from '../api'

export const useMutationFinishCreditMultiStepLoad = createReactQueryMutationHook('finishCreditMultiStepLoad', finishCreditMultiStepLoad)
